import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Component, inject, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { AccentSwitcherComponent } from "@components/accent-switcher/accent-switcher.component";

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AccentSwitcherComponent]
})
export class FooterComponent {
	private platformId = inject<Object>(PLATFORM_ID);
	private viewportScroller = inject(ViewportScroller);
	isBrowser: boolean = isPlatformBrowser(this.platformId);

	footerLinks = [
		{
			icon: "photo_camera",
			link: "https://www.instagram.com/dartegnian/",
			text: "Instagram"
		},
		{
			icon: "work",
			link: "https://www.linkedin.com/in/dartegnian/",
			text: "LinkedIn"
		},
		{
			icon: "code",
			link: "https://github.com/dartegnian",
			text: "GitHub"
		},
		{
			icon: "queue_music",
			link: "https://www.last.fm/user/Dartegnian",
			text: "Last.fm"
		},
		{
			icon: "music_note",
			link: "https://open.spotify.com/user/dartegnian",
			text: "Spotify"
		},
		{
			icon: "alternate_email",
			link: "https://mastodon.social/@dartegnian",
			text: "Mastodon"
		},
		{
			icon: "palette",
			link: "https://www.behance.net/Dartegnian",
			text: "Behance"
		},
		{
			icon: "swap_vert",
			link: "https://www.reddit.com/user/dartegnian/",
			text: "Reddit"
		},
	];

	siteLinks = [
		{
			icon: "globe_asia",
			link: "https://dartegnian.com",
			text: "Home"
		},
		{
			icon: "edit_note",
			link: "https://blog.dartegnian.com",
			text: "Blog"
		},
		{
			icon: "work_history",
			link: "https://portfolio.dartegnian.com",
			text: "Portfolio"
		},
		{
			icon: "web_stories",
			link: "https://stories.dartegnian.com",
			text: "Web Stories"
		},
		{
			icon: "rss_feed",
			link: "https://dartegnian.com/rss",
			text: "RSS Feed"
		},
	];

	constructor() { }

	scrollToTop(): void {
		this.viewportScroller.scrollToPosition([0, 0]);
	}
}
